export default __webpack_public_path__ + "static/media/CourseraLogo.f7b65261.png";